import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import DataTable from "../../../components/form/DataTable";
import Modal from '../../../components/form/Modal';
import axios from "axios";

const EnquiryReport = () => {
  const { register, handleSubmit, reset } = useForm();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [updateModalOpen, setUpdateModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const columns = [
    {
      label: (
        <div>
          <span style={{ color: "#ff0000" }}>Student’s Name</span>
          <br />
          <span style={{ color: "#1200b8ff" }}>Surname</span>
          <br />
          <span style={{ color: "#d63031" }}>Admission in Class</span>
        </div>
      ),
      field: "studentName",
    },
    {
      label: (
        <div>
          <span style={{ color: "#ff0000" }}>Father’s Name</span>
          <br />
          <span style={{ color: "#1200b8ff" }}>Father’s Contact</span>
          <br />
          <span style={{ color: "#d63031" }}>Father’s Whatsapp No</span>
        </div>
      ),
      field: "fatherName",
    },
    {
      label: (
        <div>
          <span style={{ color: "#ff0000" }}>Mother’s Name</span>
          <br />
          <span style={{ color: "#1200b8ff" }}>Mother’s Contact</span>
          <br />
          <span style={{ color: "#d63031" }}>Mother’s Whatsapp No</span>
        </div>
      ),
      field: "motherName",
    },
    {
      label: (
        <div>
          <span style={{ color: "#ff0000" }}>Visit Date</span>
          <br />
          <span style={{ color: "#1200b8ff" }}>Data Entered By</span>
          <br />
          <span style={{ color: "#d63031" }}>Data Entered Date & Time</span>
        </div>
      ),
      field: "visitInfo",
    },
    {
      label: (
        <div>
          <span style={{ color: "#ff0000" }}>Last Status Update</span>
          <br />
          <span style={{ color: "#1200b8ff" }}>Last Status Update By</span>
          <br />
          <span style={{ color: "#d63031" }}>Last Status Update Date & Time</span>
        </div>
      ),
      field: "statusInfo",
    },
    {
      label: ( <div>
          Action
        </div>
      ),
      field: "Action",
    },
  ];

  // Fetch data function
  const fetchData = () => {
    setLoading(true);
    axios.get("/api/admin/get-enquiries")
      .then(res => {
        const transformedData = res.data.map(item => ({
          studentName: (
                <div>
                <span style={{ color: "#ff0000" }}>{item.student_name || ''}</span>
                <br />
                <span style={{ color: "#1200b8ff" }}>{item.surname || ''}</span>
                <br />
                <span style={{ color: "#d63031" }}>{item.admission_class || ''}</span>
                </div>
            ),
            fatherName: (
                <div>
                <span style={{ color: "#ff0000" }}>{item.father_name || ''}</span>
                <br />
                <span style={{ color: "#1200b8ff" }}>{item.father_contact || ''}</span>
                <br />
                <span style={{ color: "#d63031" }}>{item.father_whatsapp || ''}</span>
                </div>
            ),
            motherName: (
                <div>
                <span style={{ color: "#ff0000" }}>{item.mother_name || ''}</span>
                <br />
                <span style={{ color: "#1200b8ff" }}>{item.mother_contact || ''}</span>
                <br />
                <span style={{ color: "#d63031" }}>{item.mother_whatsapp || ''}</span>
                </div>
            ),
            visitInfo: (
                <div>
                    <span style={{ color: "#ff0000" }}>{item.visit_date || '-'}</span>
                    <br />
                    <span style={{ color: "#1200b8ff" }}>{item.entered_by || '-'}</span>
                    <br />
                    <span style={{ color: "#d63031" }}>{item.entered_at || '-'}</span>
                </div>
            ),
            statusInfo: (
                <div>
                <span className="text-multiline-ellipsis" style={{ color: "#ff0000" }} title={item.last_status || '-'} >{item.last_status || '-'}</span>                
                <span style={{ color: "#1200b8ff" }}>{item.last_status_update_by || '-'}</span>
                <br />
                <span style={{ color: "#d63031" }}>{item.last_status_update_datetime || '-'}</span>
                </div>
            ),
          Action: (
            <div style={{ display: "flex", gap: "5px" }}>
              <button
                className="btn btn-success"
                onClick={() => {
                  setSelectedRow(item);
                  setViewModalOpen(true);
                }}
              >
                View Status
              </button>
              <button
                className="btn btn-primary"
                onClick={() => {
                  setSelectedRow(item);
                  reset({
                    status: "",
                    visit_date: "",
                    enquiry_id:item.id,
                    added_by:item.added_by,
                  });
                  setUpdateModalOpen(true);
                }}
              >
                Update Status
              </button>
            </div>
          ),
        }));
        setData(transformedData);
        setLoading(false);
      })
      .catch(err => {
        console.error("Error fetching enquiry data:", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, [reset]);

  // Handle update status submit
  const onSubmit = formData => {
    if (!selectedRow) return;

    axios.post(`/api/admin/update-enquiry-status/`, formData)
      .then(res => {
        alert("Status updated successfully!");
        setUpdateModalOpen(false);
        fetchData(); // Refresh table after update
      })
      .catch(err => {
        console.error("Error updating status:", err);
        alert("Failed to update status");
      });
  };

  if (loading) return <div>Loading...</div>;

  return (
    <div className="page-wrapper">
      <div className="page-content">
        <DataTable
          title="Enquiry Report"
          columns={columns}
          data={data}
          headerStyle={{ backgroundColor: "#4a90e2", color: "#fff" }}
          rowStyle={{ backgroundColor: "#f5f7fa" }}
        />

        {/* View Status Modal */}
        <Modal
          show={viewModalOpen}
          onClose={() => setViewModalOpen(false)}
          title="View Status"
          classname="modal-lg"
        >
          {selectedRow && (
            <div>
                           
              {selectedRow.status_history && selectedRow.status_history.length > 0 ? (
                selectedRow.status_history.map((statusItem, index) => (
                  <div key={index} className="mb-3">
                    <div><strong>Visit Date:</strong> {statusItem.visit_date}</div>
                    <div><strong>Status Update:</strong> {statusItem.status_date} - {statusItem.added_by || '-'}</div>
                    
                    <ul className="list-group mt-2">
                      <li className="list-group-item">
                        <div><strong>Status:</strong> {statusItem.status}</div>
                      </li>
                    </ul>
                  </div>
                ))
              ) : (
                <div>No status history available</div>
              )}
            
            </div>
          )}
        </Modal>

        {/* Update Status Modal */}
        <Modal
          show={updateModalOpen}
          onClose={() => setUpdateModalOpen(false)}
          title="Update Status"
          classname="modal-lg"
          showBtn={false}
        >
          {selectedRow && (
            <form onSubmit={handleSubmit(onSubmit)}>
              <input type="hidden" 
              {...register("enquiry_id", { required: false })}
              />
              <input type="hidden" 
              {...register("added_by", { required: false })}
              />
              
              <div className="mb-3">
                <label>Visit Date </label>
                <input
                  type="text"
                  className="form-control"
                  {...register("visit_date", { required: true })}
                  placeholder="Visit Date"
                />
              </div>

              
              <div className="mb-3">
                <label>Status</label>
                <textarea
                  className="form-control"
                  rows={3}
                  {...register("status")}
                  placeholder="Status"
                />
              </div>

              <button type="submit" className="btn btn-primary me-2">Save Changes</button>
              <button type="button" className="btn btn-secondary" onClick={() => setUpdateModalOpen(false)}>Cancel</button>
            </form>
          )}
        </Modal>
      </div>
    </div>
  );
};

export default EnquiryReport;